import React, { cloneElement } from 'react';
import { Icon, Tooltip } from 'antd';
import { FaWhatsapp } from 'react-icons/fa';

export const renderSourceIcon = (source) => {
  const sources = {
    form: {
      title: "Cadastro por formulário no site",
      icon: <Icon type="form" />,
    },
    panel: {
      title: "Cadastrado manualmente pelo painel do Contlabs",
      icon: <Icon type="setting" />,
    },
    extension: {
      title: "Cadastrado pela extensão do WhatsApp",
      icon: <FaWhatsapp />,
    },
  };

  // If no source or invalid source, show unknown icon
  if (!source || !sources[source]) {
    return (
      <Tooltip title="Desconhecido">
        {cloneElement(<Icon type="question" />, {
          style: { fontSize: 9, color: "white" },
        })}
      </Tooltip>
    );
  }

  const { title, icon } = sources[source];
  return (
    <Tooltip title={title}>
      {cloneElement(icon, {
        style: { fontSize: 9, color: "white" },
      })}
    </Tooltip>
  );
};
